export class Task {
    taskId:number
    sendNotification:boolean
    catDetTaskTypeId: number
    title: string
    catDetNotificationDateId: number
    catDetTaskRequestTypeId: number
    catDetTaskStatusId: number
    checklistId: number
    description: string
    notificationMessage:string
    isMaximumTimeRequired : boolean
    lockedBeforeReadNotif: boolean
    maximumDateRequired: any
    maximumTimeRequired: any
    campaignCalendarId: number
}